// extracted by mini-css-extract-plugin
export default {"companyListContainer":"BucketDetails_companyListContainer__5imF+","companyListHead":"BucketDetails_companyListHead__7d3LA","editButton":"BucketDetails_editButton__288+b"};